import reducers, { initState } from './payment.reducers';
import * as actions from './payment.actions';
import watch from './payment.operations';
import * as types from './payment.types';

export { initState, actions, watch, types };

export default reducers;
